import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { createHead } from '@unhead/vue/client'
import './assets/main.css'
import { useTelemetry } from './composables/useTelemetry'
import { configureEuchreSoundDefaults } from './composables/useEuchreSound'

window.__APP_VERSION__ = __APP_VERSION__

// Euchre sound (Q-73=A): seed default-ON at game-tier volume with a visible
// persistent mute (rendered by SoundToggle.vue in the game chrome). Only applies
// when the user has no stored `dcs.sound` preference, so an explicit mute is never
// overwritten. Reduced-motion auto-mute and iframe silence are enforced by the
// shared engine, not here.
configureEuchreSoundDefaults()

// Initialize telemetry early
const telemetry = useTelemetry()
telemetry.initialize()

const app = createApp(App)
const head = createHead()

app.use(createPinia())
app.use(router)
app.use(head)

// Global error handler for telemetry
app.config.errorHandler = (error, instance, info) => {
	console.error('Vue error:', error, 'Info:', info)
	if (error instanceof Error) {
		telemetry.trackException({
			exception: error,
			properties: {
				vue_error_info: info,
				component: instance?.$options.name || instance?.$options.__name || 'unknown',
			},
		})
	}
}

// Track unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
	console.error('Unhandled promise rejection:', event.reason)
	const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason))
	telemetry.trackException({
		exception: error,
		properties: {
			type: 'unhandled_promise_rejection',
		},
	})
})

app.mount('#app')
